import styled from 'styled-components';

export const Link = styled.a`
  cursor: pointer;
  border: none;
  background: transparent;
  display: flex;
  text-decoration: none;
  &:disabled {
    cursor: default;
  }
`;
